<template>
  <v-navigation-drawer
    bottom
    color="transparent"
    fixed
    height="auto"
    overlay-color="secondary"
    overlay-opacity=".8"
    temporary
    v-bind="$attrs"
    v-on="$listeners"
  >
    <v-list
      color="white"
      shaped
    >
      <template v-for="(item, index) in items">
        <v-list-group
          v-if="item.children && item.children.length"
          :key="`group-${item.id || item.src || item.i18n || index}`"
        >
          <template #activator>
            <v-list-item-content>
              <v-list-item-title v-text="item.name" />
            </v-list-item-content>
          </template>
          <!-- 新增产品子项 -->
          <v-list-item
            v-for="(child, j) in item.children"
            :key="child.id || child.src || child.i18n || `child-${j}`"
            @click="$router.push(child.src)"
          >
            <v-list-item-title>{{ child.name }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-item
          v-else
          :key="`item-${item.id || item.src || item.i18n || index}`"
          :to="item.src"
          color="primary"
        >
          <v-list-item-content>
            <v-list-item-title v-text="item.name" />
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  export default {
    name: 'HomeDrawer',

    props: {
      items: {
        type: Array,
        default: () => [],
      },
    },
  }
</script>
